var React = require('react');

function Paperplane (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28.9491 14.4488C28.9491 15.1738 28.5172 15.8297 27.8497 16.1146L2.52627 27.04C2.29619 27.1391 2.05366 27.1869 1.81316 27.1869C1.32464 27.1869 0.845173 26.9887 0.494568 26.6177C-0.0276022 26.0645 -0.147737 25.2441 0.19188 24.5633L4.36403 16.2201L18.0767 14.5L4.36312 12.7779L0.190974 4.43471C-0.148473 3.75502 -0.0281232 2.9343 0.494001 2.38148C1.01793 1.82833 1.82845 1.65932 2.5257 1.95934L27.9013 12.8345C28.5696 13.1177 28.9491 13.7747 28.9491 14.4488Z"}));
}

Paperplane.defaultProps = {"width":"29","height":"29","viewBox":"0 0 29 29","fill":"none"};

module.exports = Paperplane;

Paperplane.default = Paperplane;
